import script from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeGenerator.vue?vue&type=script&setup=true&lang=js"

import "./CodeGenerator.vue?vue&type=style&index=0&id=2cb03a80&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/transfers/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb03a80"]])

export default __exports__